import { createStore, applyMiddleware } from 'redux';
import { persistCombineReducers, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { reducer as toastr } from 'react-redux-toastr';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'react-router-redux';
import AuthRedux from './assets/redux/AuthRedux';
import ThemeRedux from './assets/redux/ThemeRedux';
import CartRedux from './assets/redux/CartItemRedux';
import DicRedux from './assets/redux/DictionaryRedux';
import SettingRedux from './assets/redux/SettingRedux';
import ProfileRedux from './assets/redux/UserProfileRedux';
import NavbarTitleRedux from './assets/redux/NavbarTitleRedux';
import navbar from './components/NavBar/reducer';
const rootPersistConfig = {

  key: 'root',
  storage,
  blacklist: [
    'navbar',
    'search',
    'toastr',
    'categories',
    'products',
    'reviews',
    'variations',
    'cart',
    'DicRedux',
    'SettingRedux'
  ],
  // debug: true,
};

const rootReducer = persistCombineReducers(rootPersistConfig, {
  navbar,
  toastr,
  AuthRedux,
  ProfileRedux,
  DicRedux,
  ThemeRedux,
  CartRedux,
  NavbarTitleRedux,
  SettingRedux
}); 

const history = createBrowserHistory();



const store = createStore(
  rootReducer,
  undefined,
  applyMiddleware(thunk, routerMiddleware(history)),
);

persistStore(store);



// const store = createStore(changeState);
export { history };
export default store;
